import { Injectable } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { ChartColorService } from './chart-color.service';

@Injectable()
export class ConfigParserService {
  constructor(private readonly chartColorService: ChartColorService) {}

  /**
   * Constructs an Option config for Chart.js based on the Galaxy Config passed in
   * @param config - Config to parse
   */
  public parseConfig(ctx: CanvasRenderingContext2D, config: ChartConfiguration) {
    // If there is no options passed in, just return out of it.
    if (!config || !config.options) {
      return {};
    }

    return this.checkForColorParsing(ctx, config.options, '');
  }

  /**
   * Parses through the GalaxyChartConfig for any *Color variables and if any are found, they are
   * parsed through the color parser.
   * @param ctx - Canvas 2D Context
   * @param currentDict - The current dictionary we are looking at
   * @param val - Current key we are looking at
   */
  private checkForColorParsing(ctx: CanvasRenderingContext2D, currentDict: any, val: any) {
    if (val.endsWith('Color')) {
      return this.chartColorService.parseColorInformation(ctx, currentDict);
    }

    const responseObject = {};
    Object.keys(currentDict).forEach((key) => {
      // If the information passed in is an object, we have to loop through those keys
      if (typeof currentDict[key] === 'object' && key !== 'scales' && key !== 'tooltip') {
        responseObject[key] = this.checkForColorParsing(ctx, currentDict[key], key);
      } else {
        responseObject[key] = currentDict[key];
      }
    });
    return responseObject;
  }
}
